import React, { forwardRef } from 'react';

// I am sorry for typing this, please do it properly in the future.
export const withForwardedRef = function <T>(Component: ReactFunction) {
    // eslint-disable-next-line react/display-name
    return forwardRef((props: T, ref) => <Component {...props} forwardedRef={ref} />);
};

type ReactFunction = (props) => JSX.Element;
